import React, { createContext, useContext, useState } from 'react';
import { getOrderDetails, getOrders, getPartnerOrders} from '../../services/api';

const OrderContext = createContext();

export const OrderProvider = ({ children }) => {
    
    const [orders, setOrders] = useState([]);
    const [orderData, setOrderData] = useState(null);
 
    const FetchOrders = async() => {
       
        const response = await getOrders();
        setOrders(response.data);
    };

    const FetchPartnerOrders = async() => {
     
        const response = await getPartnerOrders();
        setOrders(response.data);
    };
    const OrderDetails = async (id) => {

        const response = await getOrderDetails(id);       
        setOrderData(response.data);
    };
    

    return (
        <OrderContext.Provider value={{ orders, orderData, FetchPartnerOrders,FetchOrders, OrderDetails } }>
            {children}
        </OrderContext.Provider>
    );
};

export const useOrderContext = () => useContext(OrderContext);
